import { connect } from 'react-redux';
import LoginAdminPage from './Main';
import { bindActionCreators } from 'redux';
import { phonePrefixes, authorizedUser } from 'Store/Selectors/AuthSelector';
import * as Types from 'Shared/models/AuthModel';
import { Actions as AuthActions } from 'Modules/AuthModule';
import { User } from 'Shared/models/UserModel';
import { adminLogin } from 'Store/Actions/Auth';
type ConnectedP = {
  phonePrefixes: Array<Types.PhonePrefix>;
  authorizedUser: User | 'init';
};

type DispatchedP = {
  actions: {
    adminLogin: ({ email, password }) => (dispatch: any) => Promise<boolean>;
    getAuthorizedUser: () => any;
  };
};
const mapStateToProps = (state) => ({
  phonePrefixes: phonePrefixes(state),
  authorizedUser: authorizedUser(state),
});

const mapDispatchToProps = (dispatch): DispatchedP => ({
  actions: bindActionCreators(
    {
      getAuthorizedUser: AuthActions.getAuthorizedUser,
      adminLogin: adminLogin,
    },
    dispatch,
  ),
});

export type MainType = ConnectedP & DispatchedP;

export default connect(mapStateToProps, mapDispatchToProps)(LoginAdminPage);
